import { updateSyncErrors } from 'redux-form'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import {
  IValidateOldPassword,
  updatePassword,
} from '../../actions/userAccount/user/updatePassword'
import i18n from '../../i18n'
import fetchFactory from '../../models/fetch'
import authRequest from '../../models/User/authorize'
import { UpdatePasswordActions } from '../../reducers/userAccount/actionNames'
import { getUsername } from '../../reducers/userAccount/selectors/userAccount'

function* validateOldPassword(action: IValidateOldPassword) {
  try {
    const fetchModel = authRequest({
      fetch: fetchFactory('').fetch,
    })

    const username = yield select(getUsername)

    yield call(fetchModel, username, action.oldPassword)
    yield put(updatePassword(action.newPassword))
  } catch (e) {
    yield put(
      updateSyncErrors(
        'changePassword',
        { oldPassword: i18n.t('BBO_936_wrong_old_password') },
        {},
      ),
    )
  }
}

export default function* () {
  yield takeLatest(
    UpdatePasswordActions.ValidateOldPassword,
    validateOldPassword,
  )
}
